// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"pending-tasks_layoutWrapper__FgHdu"};